<div class="container">
    <div class="col">
      <form [formGroup]="ticketForm" (ngSubmit)="save()" class="text-center">
        <div class="row">
          <div class="col">
            <mat-form-field class="text-center">
              <mat-label>Prioridad</mat-label>
              <mat-select formControlName="Priority">
                <mat-option [value]="0">Baja</mat-option>
                <mat-option [value]="1">Media</mat-option>
                <mat-option [value]="2">Alta</mat-option>
              </mat-select>
              <mat-error *ngIf="ticketForm.get('Priority').hasError('required')">
                La prioridad es obligatoria.
              </mat-error>
            </mat-form-field>
            <br />
            <mat-form-field class="text-center">
              <input type="text" matInput placeholder="Asunto" formControlName="Subject" />
              <mat-error *ngIf="ticketForm.get('Subject').hasError('required')">
                El asunto es obligatorio.
              </mat-error>
            </mat-form-field>
            <br />
            <mat-form-field class="text-center">
              <mat-label>Seleccionar Módulo</mat-label>
              <mat-select formControlName="Category">
                <mat-option value="Resumen">Resumen</mat-option>
                <mat-option value="Mi cuenta">Mi cuenta</mat-option>
                <mat-option value="Conceptos">Conceptos</mat-option>
                <mat-option value="Ingresos">Ingresos</mat-option>
                <mat-option value="Gastos">Gastos</mat-option>
                <mat-option value="Inversión">Inversión</mat-option>
                <mat-option value="Finanzas">Finanzas</mat-option>
                <mat-option value="Personal">Personal</mat-option>
                <mat-option value="Contabilidad">Contabilidad</mat-option>
                <mat-option value="Fiscalidad">Fiscalidad</mat-option>
                <mat-option value="Ficheros">Ficheros</mat-option>
                <mat-option value="Otro">Otro</mat-option>
              </mat-select>
              <mat-error *ngIf="ticketForm.get('Category').hasError('required')">
                La categoría es obligatoria.
              </mat-error>
            </mat-form-field>
            <hr>
            <div class="text-center">
              <mat-form-field class="text-center">
                <textarea matInput placeholder="Mensaje" formControlName="Message" rows="4" cols="50"></textarea>
                <mat-error *ngIf="ticketForm.get('Message').hasError('required')">
                  El mensaje es obligatorio.
                </mat-error>
              </mat-form-field>
            </div>
          </div>
        </div>
  
        <ng-container *ngIf="saving">
          <div class="cf-dlg-loading"><div class="cf-dlg-loading__dots"><span></span><span></span><span></span></div></div>
        </ng-container>
        <button mat-stroked-button type="submit" [disabled]="!ticketForm.valid">
          Enviar Ticket
        </button>
      </form>
      <br />
    </div>
  </div>
  